import { z } from 'zod';

/**
 * What the money did (P31).
 *
 * - `succeeded` — the charge landed.
 * - `pending` — a transfer awaiting staff confirmation.
 * - `failed` — a refused transfer, or a store renewal in billing retry
 *   (RevenueCat's `BILLING_ISSUE`, keyed by the event id since no charge exists).
 * - `refunded` — a **status on the charge row**, never a second row: the store's
 *   `REFUND` names the transaction it reverses, and that is the row an operator
 *   asks about.
 *
 * A card refused at the store's own checkout never appears — no channel reports
 * a charge that was not attempted. The ledger page says so; the code cannot.
 */
export const PAYMENT_STATUSES = ['succeeded', 'pending', 'failed', 'refunded'] as const;

export const PaymentStatusSchema = z.enum(PAYMENT_STATUSES);

export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

const STATUS_SET: ReadonlySet<string> = new Set(PAYMENT_STATUSES);

export function isPaymentStatus(value: string): value is PaymentStatus {
  return STATUS_SET.has(value);
}
